import { observable }          from 'mobx';
import { observer }            from 'mobx-react';
import React                   from 'react';
import { PagedCollection }     from 'collections/PagedCollection';
import UserModel               from 'models/UserModel';
import { ROLE_STANDIST }       from 'constants/RoleReferences';
import Select                  from 'components/App/IntlSelect';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import { Collection }          from '@mathquis/modelx';

const { Option } = Select;

interface StandistSelectProps {
  onStandistSelect: (user: UserModel) => void;
  selectedStandistIri?: string;
  standistCollection: Collection<UserModel>;
}

class StandistSelect extends React.Component<StandistSelectProps> {
  // without that, render is not trigger
  public state = {
    isLoading: false,
  };

  @observable
  public userCollection = new PagedCollection(UserModel);

  public componentDidMount = () => {
    this.userCollection.itemsPerPage = 250;
  };

  public render() {
    const { selectedStandistIri, standistCollection } = this.props;

    const options = this.userCollection
      // .slice()
      // .filter(user => !standistCollection.findBy('@id', user.iri))
      .map((user: UserModel) => {
        const alreadyStandist = !!standistCollection.find(s => s.get('@id') === user.iri);
        return (
          <Option disabled={alreadyStandist} key={user.id} value={user.iri}>
            {user.company.toUpperCase()} - {user.fullName} ({user.email})
          </Option>
        );
      });

    return (
      <Select
        defaultActiveFirstOption={false}
        filterOption={false}
        loading={this.state.isLoading}
        notFoundContent={<FormattedMessageWrapper id="Aucun résultat" />}
        onChange={this.handleSelectUser}
        onSearch={this.fetchUserCollection}
        placeholder="Rechercher un utilisateur"
        showArrow={false}
        showSearch
        style={{ width: '100%' }}
        value={selectedStandistIri}
      >
        {options}
      </Select>
    );
  }

  private fetchUserCollection = async (value: any) => {
    this.setState({ isLoading: true });

    this.userCollection.clear();

    if (value.length >= 1) {
      this.userCollection.setFilters({
        'role.reference': ROLE_STANDIST,
        search: value,
      });
    } else {
      this.userCollection.setFilters({
        'role.reference': ROLE_STANDIST,
      });
    }

    await this.userCollection.list();

    this.setState({ isLoading: false });
  };

  private handleSelectUser = (modelIri: string) => {
    const selectedUser = this.userCollection.findBy('@id', modelIri) as UserModel;

    if (selectedUser) {
      this.props.onStandistSelect(selectedUser);
    }
  };
}

const StandistSelectObserver = observer(StandistSelect);

export default StandistSelectObserver;
